import { render, staticRenderFns } from "./layout-right.vue?vue&type=template&id=2af3c195&scoped=true&"
import script from "./layout-right.vue?vue&type=script&lang=js&"
export * from "./layout-right.vue?vue&type=script&lang=js&"
import style0 from "./layout-right.vue?vue&type=style&index=0&id=2af3c195&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af3c195",
  null
  
)

export default component.exports